module.exports = __webpack_public_path__ + "img/6.f26bc5d6.jpg";